
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartLegend, ChartLegendContent } from '@/components/ui/chart';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from 'recharts';
import { chemicalSafetyBarData } from '@/data/chemicalSafetyData';

const chartConfig = {
  yourScore: {
    label: 'Your Score',
    color: '#3b82f6'
  },
  industryAverage: {
    label: 'Industry Average',
    color: '#94a3b8'
  },
  topPerformer: {
    label: 'Top Performer',
    color: '#22c55e'
  }
};

export const SafetyBarChart = () => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Safety Endpoint Comparison</CardTitle>
        <p className="text-sm text-muted-foreground">
          Detailed comparison across safety endpoints
        </p>
      </CardHeader>
      <CardContent className="p-4">
        <ChartContainer config={chartConfig} className="h-[400px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart 
              data={chemicalSafetyBarData} 
              margin={{ top: 20, right: 20, left: 20, bottom: 80 }}
            >
              <XAxis 
                dataKey="endpoint" 
                angle={-45} 
                textAnchor="end" 
                height={80} 
                interval={0}
                tick={{ fontSize: 10 }}
              />
              <YAxis tick={{ fontSize: 10 }} />
              <ChartTooltip content={<ChartTooltipContent />} />
              <ChartLegend content={<ChartLegendContent />} />
              <Bar dataKey="yourScore" fill="var(--color-yourScore)" radius={[2, 2, 0, 0]}>
                <LabelList dataKey="yourScore" position="top" fontSize={8} />
              </Bar>
              <Bar dataKey="industryAverage" fill="var(--color-industryAverage)" radius={[2, 2, 0, 0]}>
                <LabelList dataKey="industryAverage" position="top" fontSize={8} />
              </Bar>
              <Bar dataKey="topPerformer" fill="var(--color-topPerformer)" radius={[2, 2, 0, 0]}>
                <LabelList dataKey="topPerformer" position="top" fontSize={8} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
